// extracted by mini-css-extract-plugin
export var indexIcon = "tutorialicon-module--indexIcon--1nEAW";
export var item = "tutorialicon-module--item--1rElM";
export var indexItem = "tutorialicon-module--indexItem--6PJu5";
export var mini = "tutorialicon-module--mini--3LViN";
export var bar = "tutorialicon-module--bar--1wHqC";